import { Collapse } from "antd";
import styled from "styled-components";

export const PosicaoCardStyled = styled(Collapse.Panel)`
  border-radius: 0 !important;
  background-color: var(--velotax-background-color-ghost);
  border-bottom: 1px solid var(--velotax-background-color) !important;

  &:last-of-type {
    border-bottom: none !important;
  }

  .ant-collapse-content {
    border-color: transparent;
    border-radius: 0 0 4px 4px !important;
    background-color: var(--velotax-background-color-ghost);

    .ant-collapse-content-box {
      padding-top: 0;
      color: var(--velotax-font-color-light);
    }
  }
`;
